import { useMemo } from "react";

import Bold from "@gx/dls/text/Bold";
import Text, { TextSize, TextVariant } from "@gx/dls/text/Text";
import { SourceResource } from "@gx/ts-contracts/services/source/resources/source_pb";

import { convertProtobufTimestampToDate, formatDate } from "@/utils/datetimes";
import { getUserFullName } from "@/utils/users";

interface SourceCardFooterProps {
  user: SourceResource["createdBy"];
  deletedAt: SourceResource["deletedAt"];
  createdAt: SourceResource["createdAt"];
}

const SourceCardFooter = ({ user, deletedAt, createdAt }: SourceCardFooterProps) => {
  const createdAtDate = useMemo(() => {
    return createdAt ? convertProtobufTimestampToDate(createdAt) : null;
  }, [createdAt]);

  const deletedAtDate = useMemo(() => {
    return deletedAt ? convertProtobufTimestampToDate(deletedAt) : null;
  }, [deletedAt]);

  if (deletedAt) {
    return (
      <Text size={TextSize.BODY_SM} variant={TextVariant.TERTIARY}>
        Deleted by <Bold>{getUserFullName(user)}</Bold> on{" "}
        {deletedAtDate ? formatDate(deletedAtDate.toISOString()) : "—"}
      </Text>
    );
  }

  return (
    <Text size={TextSize.BODY_SM} variant={TextVariant.TERTIARY}>
      Created by <Bold>{getUserFullName(user)}</Bold> on{" "}
      {createdAtDate ? formatDate(createdAtDate.toISOString()) : "—"}
    </Text>
  );
};

export default SourceCardFooter;
